import * as React from "react";

;
export const GoesDown = (props: React.SVGProps<SVGSVGElement>) => <svg width={12} height={14} fill="#d93025" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M6.05 11.063V-19h-.9v30.063C4.22 6.289 2.62 2.833.6 2.833v3c2.716 0 4.54 7.524 4.55 15.109V21h.9c0-7.604 1.827-15.167 4.55-15.167v-3c-2.02 0-3.62 3.457-4.55 8.23z" /></svg>;